export default __webpack_public_path__ + "static/emp-icn2-14e2c8b9a60c90044ff85a931864f632.png";